/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { Card, CardContent, Grid } from "@mui/material";
import AssessmentStatusLabel from "../AssessmentStatusLabel/AssessmentStatusLabel";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
  },
  content: {
    paddingLeft: theme.spacing(3),
  },
  label: {
    fontWeight: "bold",
    marginRight: theme.spacing(2),
  },
}));

function VendorDetailCard(props) {
  const { data, mode, className, type, ...rest } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Card variant="outlined" className={classes.root}>
      <CardContent>
        {type === 2 ? (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={3} lg={2}>
              <p className={classes.label}>{t("EvaluationPtt.taxNumber")}</p>
              <p>{data.vatRegistrationNo || ""}</p>
            </Grid>
            <Grid item xs={12} sm={12} md={9} lg={5}>
              <p className={classes.label}>{t("VendorSelf.vendorCodeName")}</p>
              <p>{data.vendorCode || ""} - {data.vendorNameMain || ""}</p>
            </Grid>
            <Grid item xs={12} sm={5} md={3} lg={2}>
              <p className={classes.label}>{t("vendorSite.result")}</p>
              <p><AssessmentStatusLabel statusCode={data.resultCode || ""} /></p>
            </Grid>
            <Grid item xs={12} sm={4} md={3} lg={2}>
              <p className={classes.label}>{t("vendorSite.score")}</p>
              <p>{parseFloat(data.averageScore || 0).toFixed(2) || "-"}</p>
            </Grid>
            <Grid item xs={12} sm={3} md={2} lg={1}>
              <p className={classes.label}>{t("VendorRegis.fullScore")}</p>
              <p>{parseFloat(data.fullScore || 0).toFixed(2) || "-"}</p>
            </Grid>
          </Grid>
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={3} lg={3}>
              <p className={classes.label}>{t("EvaluationPtt.taxNumber")}</p>
              <p>{data.vatRegistrationNo || ""}</p>
            </Grid>
            <Grid item xs={12} sm={12} md={5} lg={5}>
              <p className={classes.label}>{t("VendorSelf.vendorCodeName")}</p>
              <p>{data.vendorCode || ""} - {data.vendorNameMain || ""}</p>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <p className={classes.label}>{t("VendorSelf.operatedBy")}</p>
              <p>{data.operationStaff || ""}</p>
            </Grid>
          </Grid>
        )}
      </CardContent>
    </Card>
  );
}

VendorDetailCard.propTypes = {
  className: PropTypes.string,
  data: PropTypes.object,
  mode: PropTypes.string,
  type: PropTypes.number,
};

export default VendorDetailCard;
